import FeaturedContentBlock from "./FeaturedContentBlock";

export default FeaturedContentBlock;
